import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const ShowDoc = (props: { btnName: string; url: string }) => {
  // ต้องมี ชื่อปุ่ม กับลิงค์มา
  const { url, btnName } = props;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-secondary"
        onClick={handleShow}
      >
        <i className="bi bi-cloud-arrow-up-fill"></i> ดู {btnName}
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            เอกสาร {btnName}
          </Modal.Title>
        </Modal.Header>{" "}
        <Modal.Body>
          <iframe
            className="container-fluid"
            src={encodeURI(`${url}`)}
            frameBorder="0"
            style={{ height: "100vh" }}
          ></iframe>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ShowDoc;
